import React from 'react';
import { styled } from '@mui/material/styles';
import { Navigate, useParams, useNavigate } from 'react-router';

// Material Ui
import { Grid, Box, Typography, Button, Container } from '@mui/material';

// Custom Ui
import { connect } from 'react-redux';
import BackgroundImage from '../../public/images/login/background1.webp';
import APROLogo from '../../public/images/logo/logo-160x160-login.png';

// Redux
import axios from '../../axios';
import * as userActions from '../../store/actions/user';

const PREFIX = 'Register';

const classes = {
	root: `${PREFIX}-root`,
	textContainer: `${PREFIX}-textContainer`,
	image: `${PREFIX}-image`,
	marginBottom: `${PREFIX}-marginBottom`,
	errrorMessage: `${PREFIX}-errrorMessage`,
	googleLogo: `${PREFIX}-googleLogo`,
	loginSection: `${PREFIX}-loginSection`
};

const StyledGrid = styled(Grid)(({ theme }) => ({
	[`&.${classes.root}`]: {
		height: '100%',
		position: 'absolute'
	},

	[`&.${classes.textContainer}`]: {
		marginRight: '5%',
		marginLeft: '5%',
		[theme.breakpoints.up('sm')]: {
			marginRight: '10%',
			marginLeft: '10%'
		}
	},

	[`& .${classes.image}`]: {
		[theme.breakpoints.up('md')]: {
			display: 'block'
		},
		display: 'none',
		backgroundImage: `url(${BackgroundImage})`,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'right',
		minHeight: '100vh',
		height: 'auto'
	},

	[`& .${classes.marginBottom}`]: {
		marginBottom: theme.spacing(3)
	},

	[`& .${classes.errrorMessage}`]: {
		marginTop: theme.spacing(3)
	},

	[`& .${classes.googleLogo}`]: {
		marginRight: theme.spacing(1)
	},

	[`& .${classes.registerSection}`]: {
		marginTop: theme.spacing(3)
	}
}));

export function UnverifiedEmail({ isAuthenticated, updateUserStatus }) {
	const params = useParams();
	const navigate = useNavigate();

	if (isAuthenticated) {
		return <Navigate to="/" />;
	}

	const sendEmail = async (email) => {
		const res = await sendEmailVerificationAsync(email);

		if (res.status === 202) {
			updateUserStatus({
				statusMessage:
					'Mai este doar un pas! Un e-mail de activare a fost trimis catre tine. Caută-l atât in inbox cât şi in spam'
			});
			navigate('/login');
		} else {
			updateUserStatus({
				statusMessage:
					'Ne pare rau dar nu putem verifica acest email. Te rugam sa ne contactezi la contact@admiterepolitie.ro'
			});
			navigate('/login');
		}
	};

	const sendEmailVerificationAsync = async (email) => {
		const url = `/api/emailVerification/${email}`;
		const res = await axios.get(url);

		return res;
	};

	return (
		<StyledGrid container className={classes.root}>
			<Grid item xs={12} sm={12} md={5} className={classes.registerSection}>
				<Box
					display="flex"
					flexDirection="column"
					height="100%"
					alignItems="center"
					justifyContent="center"
					className={classes.textContainer}
				>
					<img src={APROLogo} height="150px" alt="APRO logo" />
					<Typography className={classes.marginBottom} variant="h6">
						Ups ceva este gresit!
					</Typography>
					<Box alignItems="center" justifyContent="center">
						<Container>
							<Grid item>
								<Typography
									sx={{ textAlign: 'center' }}
									className={classes.marginBottom}
									variant="body1"
								>
									Se pare ca acest cont nu este verificat!
								</Typography>
								<Typography
									sx={{ textAlign: 'center' }}
									className={classes.marginBottom}
									variant="body1"
									gutterBottom
								>
									Pentru a continua procesul si a primi un nou email de verificare apasa pe butonul
									urmator.
								</Typography>
								<Typography
									sx={{ textAlign: 'center' }}
									className={classes.marginBottom}
									variant="body1"
									gutterBottom
								>
									<Button
										variant="contained"
										sx={{ aklign: 'center' }}
										onClick={() => {
											sendEmail(params.email);
										}}
									>
										Trimite
									</Button>
								</Typography>
							</Grid>
						</Container>
					</Box>
				</Box>
			</Grid>
			<Grid item xs={12} sm={12} md={7} className={classes.image} />
		</StyledGrid>
	);
}

const mapStateToProps = (state) => ({
	isAuthenticated: state.user.isAuthenticated
});

const mapDispatchToProps = {
	updateUserStatus: userActions.updateUserStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(UnverifiedEmail);
